module.exports = __webpack_public_path__ + "static/media/sgp.56d926b0.jpg";